import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

// TODO: don't transform icons here, just use transformed icons
const Icon = styled.img`
  height: 30px;
  ${ ({flipX}) => flipX && "transform: scaleX(-1);" }
`;

const IconContainer = styled.div`
  width: 30px;
  display: flex;
  justify-content: center;
`;

const TitleContainer = styled.div`
  width: calc(100% - 30px);
  padding-left: 10px;
`;

export default class NavbarIcon extends React.Component {
  render() {
    const { title, icon, flipX } = this.props;
    return (
      <Wrapper>
        <IconContainer>
          <Icon src={icon} flipX={flipX} />
        </IconContainer>
        <TitleContainer>
          {title}
        </TitleContainer>
      </Wrapper>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/NavBar/NavbarIcon.js